import { Extra, Share } from "@xlabmedical/medic-api";
import { devLogger } from "@xlabmedical/medic-web-framework";

export const PATIENT_LIST_PAGE_SIZE = 30;
export const PATIENT_LIST_MAX_API_PAGE = 30;

export interface PatientListModel {
    patientName: string;
    note?: string;
    dateOfBirth?: Date;
    importDate?: Date;
    lastModified?: Date;
    user?: string;
    status?: string;
    patientId?: string;
    unreadNotifications?: number;
    firstName?: string;
    lastName?: string;
    extra: Extra;
    unreadChatCounts: number[];
    hasWeblinkOrder: boolean;
    lastProjectStep: string;
    lastProjectStatus: string;
    shares: Share[];
    mine?: boolean;
    uuid?: string;
    hasAccess?: boolean;
    projectUnreadNotificationsPerChannel: number;
    orderUnreadNotificationsPerChannel: number;
    orderStatusColor?: string;
    orderProjectId?: number;
    foreignOwner?: string;
    hasLegacyProject?: boolean;
}

export interface LoadPatientListSlimModel {
    page: number;
    itemsPerPage: number;
    search: string;
    sortColumn: "LAST_MODIFIED" | "NAME" | "BIRTH_DATE" | "LATEST_STEP";
    sortDirection: "ASC" | "DESC";
    filterPatients: "MY" | "ALL" | "SHARED";
    modifiedFrom?: string | null;
    modifiedTo?: string | null;
}

export function defaultLoadPatientListSlimModel(): LoadPatientListSlimModel {
    return {
        page: 0,
        itemsPerPage: PATIENT_LIST_PAGE_SIZE,
        search: "",
        sortColumn: "LAST_MODIFIED",
        sortDirection: "DESC",
        filterPatients: "ALL",
        modifiedFrom: null,
        modifiedTo: null,
    };
}

export function useDynamicRowCount() {
    const { height } = useWindowSize();

    return computed(() => {
        const h = height.value;

        const extraPenalty = Math.max(0, 900 - h) * 0.35;
        const overhead = 370 + extraPenalty;
        const rowH = h < 768 ? 92 : h < 1024 ? 86 : 80;

        const rows = Math.floor((h - overhead) / rowH);

        devLogger.debug("useDynamicRowCount rows: ", rows);

        return Math.max(rows, 1);
    });
}
